import React, { useEffect } from 'react';
import styles from './AlertDialog.module.css';

export interface AlertDialogProps {
  title: string;
  message: string;
  type?: 'error' | 'warning';
  confirmText?: string;
  onClose: () => void;
}

const AlertDialog: React.FC<AlertDialogProps> = ({
  title,
  message,
  type = 'error',
  confirmText = 'אישור',
  onClose,
}) => {
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  const handleBackdropClick = (event: React.MouseEvent) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.backdrop} onClick={handleBackdropClick}>
      <div
        className={styles.dialog}
        role="alertdialog"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-message"
      >
        <div className={styles.header}>
          <div className={`${styles.icon} ${type === 'warning' ? styles.iconWarning : styles.iconError}`}>
            {type === 'warning' ? '!' : '×'}
          </div>
          <h3 id="alert-dialog-title" className={styles.title}>
            {title}
          </h3>
        </div>
        <div id="alert-dialog-message" className={styles.message}>
          {message}
        </div>
        <div className={styles.actions}>
          <button type="button" className={styles.button} onClick={onClose} autoFocus>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertDialog;
